module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "حقوق-النشر"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حقوق النشر")]), _vm._v("©")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("د. مجدي عز الدين حنفي 2023")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يمتلك د. مجدي عز الدين حنفي")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الحق كمؤلف")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لهذا العمل، وفقًا للقانون الاتحادي رقم (")]), _vm._v("7"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(") لدولة الإمارات العربية المتحدة، لسنة")]), _vm._v(" 2002 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("م، في شأن حقوق المؤلف والحقوق المجاورة.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جميع الحقوق محفوظة")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا يحق إعادة إنتاج أي جزء من هذا الكتاب، أو تخزينه، أو نقله، أو نسخه بأي وسيلة ممكنة؛ سواء كانت إلكترونية، أو ميكانيكية، أو نسخة تصويرية، أو تسجيلية، أو غير ذلك دون الحصول على إذن مسبق من الناشرين.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أي شخص يرتكب أي فعل غير مصرح به في سياق المذكور أعلاه، قد يكون عرضة للمقاضاة القانونية والمطالبات المدنية بالتعويض عن الأضرار.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تم تصنيف وتحديد الفئة العمرية التي تلائم محتوى الكتب وفقًا لنظام التصنيف العمري الصادر عن وزارة الثقافة والشباب.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرقم الدولي الموحد للكتاب 9789948786290 (غلاف ورقي)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرقم الدولي الموحد للكتاب 9789948786306")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("(كتاب إلكتروني)")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رقم الطلب:")]), _vm._v("MC-10-01-5955612")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التصنيف العمري")]), _vm._v("E :")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الطبعة الأولى 2023")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أوستن ماكولي للنشر م. م. ح")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مدينة الشارقة للنشر")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صندوق بريد [")]), _vm._v("519201"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("]")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشارقة، الإمارات العربية المتحدة")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_vm._v("www.austinmacauley.ae")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_vm._v("202 95 655 971+   ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "font-family": "Times New Roman !important",
      "font-size": "12pt"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 69
// module chunks = 0